import { render, staticRenderFns } from "./NominationForm.vue?vue&type=template&id=a361fade&"
import script from "./NominationForm.vue?vue&type=script&lang=js&"
export * from "./NominationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports